import MainPagePresenter from "./MainPagePresenter";
import { getAllSchemasUseCase } from "../../usecases/schema/usecases";
import { getCurrentUserUseCase, signOutUseCase } from "../../usecases/user";
import { Routes, Route } from "react-router-dom";
import { OffCanvas } from "../../nq-component";
import CollectionListPage from "../collection-list/CollectionListPage";
import CollectionFormPage from "../collection-form/CollectionFormPage";
import BasePage from "../../base/BasePage";
import NotFoundPage from "../notfound";
import { Layout, Progress, LogoHolder } from "../../nq-component";
import MigrationPage from "../migration/MigrationPage";
import AccountPage from "../account/AccountPage";
import RoleFormPage from "../role-form/RoleFormPage";
import withRouter from "../../withRouter";
import HooksPage from "../web-hook/HooksPage";
import FunctionPage from "../web-hook/FunctionPage";
import SchemaPage from "../schema/SchemaPage";
import menus from "./menus.json";
import SaleTransPage from "../sales-and-transactions/SaleTransPage";
import GrossSalesPage from "../gross-sales/GrossSalesPage";
import TotalTransactionPage from "../total-transaction/TotalTransactionPage";
import TotalGuestPage from "../total-guest/TotalGuestPage";
import DiscountCostPage from "../discount-cost/DiscountCostPage";
import ProductsPage from "../products/ProductsPage";
import ItemSoldPage from "../products/chart/item-sold/ItemSoldPage";
import CustomerPage from "../customer/CustomerPage";
import ReportPage from "../report/ReportPage";
import ReportDashPage from "../report/ReportDashPage";
import { findObjectUseCase, getObjectUseCase } from "../../usecases/object";
import Top10ItemsPage from "../products/chart/top10-menu-items/Top10ItemsPage";
import LogsPage from "../logs/LogsPage";
import TransactionPage from "../transactions/TransactionPage";
import RawMaterialPage from "../food-cost/Item-master-list/raw-materials/list/RawMaterialPage";
import RawMaterialFormPage from "../food-cost/Item-master-list/raw-materials/form/RawMaterialFormPage";
import ComponentsPage from "../food-cost/Item-master-list/components/list/ComponentsPage";
import ComponentsFormPage from "../food-cost/Item-master-list/components/form/ComponentsFormPage";
import ProductPage from "../food-cost/Item-master-list/products/list/ProductPage";
import ProductFormPage from "../food-cost/Item-master-list/products/form/ProductFormPage";
import AuditLogsPage from "../food-cost/audit-logs/list/AuditLogsPage";
import InventoryPage from "../food-cost/inventory-management/inventory/list/InventoryPage";
import InventoryFormPage from "../food-cost/inventory-management/inventory/form/InventoryFormPage";
import InventoryLogsPage from "../food-cost/inventory-management/inventory-logs/list/InventoryLogsPage";
import PullOutPage from "../food-cost/pull-out-from-backup/list/PullOutPage";
import PullOutFormPage from "../food-cost/pull-out-from-backup/form/PullOutFormPage";
import DirectPurchacePage from "../food-cost/direct-purchase/list/DirectPurchacePage";
import DirectPurchaseFormPage from "../food-cost/direct-purchase/form/DirectPurchaseFormPage";
import StockRequestPage from "../food-cost/stock-transfer/stock-requests/list/StockRequestPage";
import StockRequestFormPage from "../food-cost/stock-transfer/stock-requests/form/StockRequestFormPage";
import TransferHistoryPage from "../food-cost/stock-transfer/transfer-history/list/TransferHistoryPage";
import TransferHistoryFormPage from "../food-cost/stock-transfer/transfer-history/form/TransferHistoryFormPage";
import UpcomingRequestPage from "../food-cost/stock-transfer/upcoming-requests/list/UpcomingRequestPage";
import UpcomingRequestFormPage from "../food-cost/stock-transfer/upcoming-requests/form/UpcomingRequestFormPage";
import PackagingBreakdownPage from "../food-cost/packaging-breakdown/list/PackagingBreakdownPage";
import PackagingBreakdownFormPage from "../food-cost/packaging-breakdown/form/PackagingBreakdownFormPage";
import ReceivableItemPage from "../food-cost/receivable-item/list/ReceivableItemPage";
import ReceivableItemFormPage from "../food-cost/receivable-item/form/ReceivableItemFormPage";
import WasteRawPage from "../food-cost/waste-management/waste-raw/list/WasteRawPage";
import WasteComponentPage from "../food-cost/waste-management/waste-component/list/WasteComponentPage";
import WasteProductPage from "../food-cost/waste-management/waste-product/list/WasteProductPage";
import ReportsPage from "../food-cost/reports/list/ReportsPage";
import ReceivableItemFormViewPage from "../food-cost/receivable-item/form/ReceivableItemFormViewPage";
import WasteRawFormPage from "../food-cost/waste-management/waste-raw/form/WasteRawFormPage";
import WasteComponentFormPage from "../food-cost/waste-management/waste-component/form/WasteComponentFormPage";
import WasteProductFormPage from "../food-cost/waste-management/waste-product/form/WasteProductFormPage";
import ProductSearchPage from "../products/ProductSearchPage";
import CategoryPage from "../food-cost/Item-master-list/category/list/CategoryPage";
import CategoryFormPage from "../food-cost/Item-master-list/category/form/CategoryFormPage";
import PartialLogsPage from "../food-cost/inventory-management/partial-logs/list/PartialLogsPage";
import PartialLogsFormPage from "../food-cost/inventory-management/partial-logs/form/PartialLogsFormPage";
import Menu from "../../components/Menu";

class MainPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter(
      this,
      getCurrentUserUseCase(),
      findObjectUseCase(),
      signOutUseCase(),
      getAllSchemasUseCase(),
      getObjectUseCase(),
    );
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    this.startInactivityListener();
  }

  INACTIVITY_LIMIT = 3 * 60 * 60 * 1000;
  inactivityTimer = null;

  componentWillUnmount() {
    this.cleanupInactivityListener();

    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
  }

  startInactivityListener() {
    const events = [
      "mousemove",
      "mousedown",
      "keypress",
      "scroll",
      "touchstart",
    ];
    this.resetInactivityTimer = this.resetInactivityTimer.bind(this);
    events.forEach((event) =>
      window.addEventListener(event, this.resetInactivityTimer),
    );
    this.resetInactivityTimer();
  }

  resetInactivityTimer() {
    clearTimeout(this.inactivityTimer);
    this.inactivityTimer = setTimeout(() => {
      this.presenter.onInactivityLogout();
    }, this.INACTIVITY_LIMIT);
  }

  cleanupInactivityListener() {
    const events = [
      "mousemove",
      "mousedown",
      "keypress",
      "scroll",
      "touchstart",
    ];
    events.forEach((event) =>
      window.removeEventListener(event, this.resetInactivityTimer),
    );
    clearTimeout(this.inactivityTimer);
  }

  onClickSignOut() {
    this.presenter.onClickSignOut();
  }

  onClickMenu(e, item) {
    e.preventDefault();
    this.navigateTo(item.route);
  }

  filterAccess(menus, roles) {
    return menus.filter((menu) => {
      if (Array.isArray(menu.route)) {
        menu.route = this.filterAccess(menu.route, roles);
      }
      if (!menu.access) {
        return true;
      }
      if (roles.some((role) => menu.access.includes(role?.id))) {
        return true;
      }
      return false;
    });
  }

  render() {
    const user = this.getCurrentUser();
    const schemas = this.getSchemas();
    const roles = this.getCurrentRoles();
    const menu = [...menus];

    if (user === undefined || schemas === undefined) {
      return <Progress />;
    }

    return (
      <Layout>
        <Layout.Context.Consumer>
          {(value) => (
            <OffCanvas onSetShow={value.setCollapse} show={value.collapsed}>
              {/* <div
                className="offcanvas-body p-0 gradient-background text-white"
                style={{
                  background:
                    "linear-gradient(180deg, #1F4D2C 0%, #0F2818 100%)",
                  minHeight: "100vh",
                  fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                  boxShadow: "4px 0 20px rgba(0, 0, 0, 0.3)",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: 0,
                    left: 0,
                    pointerEvents: "none",
                    opacity: 0.04,
                    zIndex: 0,
                  }}
                >
                  <i
                    className="bi bi-cup-hot-fill"
                    style={{
                      position: "absolute",
                      fontSize: "80px",
                      color: "#fff",
                      top: "15%",
                      right: "-10px",
                      transform: "rotate(15deg)",
                    }}
                  ></i>
                  <div
                    style={{
                      position: "absolute",
                      top: "35%",
                      left: "-15px",
                      transform: "rotate(-20deg)",
                    }}
                  >
                    <i
                      className="bi bi-triangle-fill"
                      style={{ fontSize: "70px", color: "#fff" }}
                    ></i>
                    <i
                      className="bi bi-circle-fill"
                      style={{
                        position: "absolute",
                        fontSize: "8px",
                        color: "#fff",
                        top: "20px",
                        left: "25px",
                      }}
                    ></i>
                    <i
                      className="bi bi-circle-fill"
                      style={{
                        position: "absolute",
                        fontSize: "6px",
                        color: "#fff",
                        top: "30px",
                        left: "32px",
                      }}
                    ></i>
                    <i
                      className="bi bi-circle-fill"
                      style={{
                        position: "absolute",
                        fontSize: "7px",
                        color: "#fff",
                        top: "25px",
                        left: "18px",
                      }}
                    ></i>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      top: "25%",
                      right: "15px",
                      transform: "rotate(35deg)",
                    }}
                  >
                    <i
                      className="bi bi-triangle-fill"
                      style={{ fontSize: "60px", color: "#fff" }}
                    ></i>
                    <i
                      className="bi bi-circle-fill"
                      style={{
                        position: "absolute",
                        fontSize: "7px",
                        color: "#fff",
                        top: "18px",
                        left: "20px",
                      }}
                    ></i>
                    <i
                      className="bi bi-circle-fill"
                      style={{
                        position: "absolute",
                        fontSize: "6px",
                        color: "#fff",
                        top: "24px",
                        left: "26px",
                      }}
                    ></i>
                    <i
                      className="bi bi-circle-fill"
                      style={{
                        position: "absolute",
                        fontSize: "5px",
                        color: "#fff",
                        top: "20px",
                        left: "15px",
                      }}
                    ></i>
                  </div>
                  <i
                    className="bi bi-egg-fried"
                    style={{
                      position: "absolute",
                      fontSize: "65px",
                      color: "#fff",
                      top: "55%",
                      right: "5px",
                      transform: "rotate(25deg)",
                    }}
                  ></i>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "25%",
                      left: "5px",
                      transform: "rotate(-35deg)",
                    }}
                  >
                    <i
                      className="bi bi-triangle-fill"
                      style={{ fontSize: "55px", color: "#fff" }}
                    ></i>
                    <i
                      className="bi bi-circle-fill"
                      style={{
                        position: "absolute",
                        fontSize: "6px",
                        color: "#fff",
                        top: "16px",
                        left: "18px",
                      }}
                    ></i>
                    <i
                      className="bi bi-circle-fill"
                      style={{
                        position: "absolute",
                        fontSize: "5px",
                        color: "#fff",
                        top: "22px",
                        left: "23px",
                      }}
                    ></i>
                    <i
                      className="bi bi-circle-fill"
                      style={{
                        position: "absolute",
                        fontSize: "6px",
                        color: "#fff",
                        top: "18px",
                        left: "13px",
                      }}
                    ></i>
                  </div>
                  <i
                    className="bi bi-cup-straw"
                    style={{
                      position: "absolute",
                      fontSize: "75px",
                      color: "#fff",
                      bottom: "15%",
                      left: "-5px",
                      transform: "rotate(-15deg)",
                    }}
                  ></i>
                  <i
                    className="bi bi-cup-hot-fill"
                    style={{
                      position: "absolute",
                      fontSize: "50px",
                      color: "#fff",
                      bottom: "35%",
                      right: "10px",
                      transform: "rotate(-30deg)",
                    }}
                  ></i>
                </div>
                <nav
                  className="d-flex flex-column h-100"
                  style={{ position: "relative", zIndex: 1 }}
                >
                  <div
                    className="text-center py-4 px-3"
                    style={{
                      borderBottom: "1px solid rgba(131, 193, 74, 0.3)",
                      background:
                        "linear-gradient(180deg, rgba(131, 193, 74, 0.12) 0%, rgba(0,0,0,0.1) 100%)",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: "2px",
                        background:
                          "linear-gradient(90deg, transparent 0%, rgba(131, 193, 74, 0.6) 50%, transparent 100%)",
                      }}
                    ></div>

                    <div
                      style={{
                        display: "inline-block",
                        padding: "4px",
                        borderRadius: "50%",
                        background:
                          "linear-gradient(135deg, #83c14a 0%, #6fa83e 50%, #5a8f32 100%)",
                        marginBottom: "12px",
                        boxShadow:
                          "0 4px 20px rgba(131, 193, 74, 0.4), 0 0 0 3px rgba(131, 193, 74, 0.15)",
                      }}
                    >
                      <LogoHolder
                        className="bg-white shadow-lg"
                        textClassName="text-dark"
                        logo={user.picture}
                        name={user.username}
                        style={{ border: "3px solid #fff" }}
                      />
                    </div>

                    <div
                      style={{
                        background:
                          "linear-gradient(135deg, rgba(131, 193, 74, 0.2) 0%, rgba(131, 193, 74, 0.1) 100%)",
                        padding: "8px 16px",
                        borderRadius: "12px",
                        marginBottom: "10px",
                        border: "1px solid rgba(131, 193, 74, 0.3)",
                        backdropFilter: "blur(10px)",
                      }}
                    >
                      <p
                        className="text-white mb-0 fw-bold"
                        style={{
                          fontSize: "0.95rem",
                          letterSpacing: "0.3px",
                          lineHeight: "1.4",
                          textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                        }}
                      >
                        {user.name || user.username}
                      </p>
                    </div>

                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        background:
                          "linear-gradient(135deg, rgba(131, 193, 74, 0.3) 0%, rgba(131, 193, 74, 0.15) 100%)",
                        padding: "6px 14px",
                        borderRadius: "20px",
                        border: "1px solid rgba(131, 193, 74, 0.5)",
                        boxShadow:
                          "0 2px 8px rgba(131, 193, 74, 0.3), inset 0 1px 0 rgba(255,255,255,0.1)",
                      }}
                    >
                      <div
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          background:
                            "linear-gradient(135deg, #83c14a 0%, #6fa83e 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 6px rgba(131, 193, 74, 0.4)",
                        }}
                      >
                        <i
                          className="bi bi-cup-hot-fill"
                          style={{ color: "#fff", fontSize: "0.65rem" }}
                        ></i>
                      </div>
                      <small
                        className="fw-bold"
                        style={{
                          color: "#fff",
                          fontSize: "0.7rem",
                          letterSpacing: "0.8px",
                          textTransform: "uppercase",
                          textShadow: "0 1px 2px rgba(0,0,0,0.3)",
                        }}
                      >
                        BI - Analytics
                      </small>
                    </div>
                  </div>

                  <div
                    className="flex-grow-1 overflow-auto px-2 py-3"
                    style={{
                      scrollbarWidth: "thin",
                      scrollbarColor: "rgba(255,255,255,0.2) transparent",
                    }}
                  >
                    <Menu
                      onClickItem={this.onClickMenu.bind(this)}
                      menus={this.filterAccess(menus, roles)}
                    />
                  </div>

                  <div
                    className="mt-auto"
                    style={{
                      background:
                        "linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.3) 100%)",
                      borderTop: "1px solid rgba(131, 193, 74, 0.3)",
                      padding: "16px 12px",
                    }}
                  >
                    <button
                      className="nav-link text-white btn btn-link w-100 text-start p-0 d-flex align-items-center justify-content-between"
                      onClick={this.onClickSignOut.bind(this)}
                      style={{
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        padding: "12px 16px",
                        borderRadius: "10px",
                        border: "1.5px solid rgba(131, 193, 74, 0.3)",
                        background:
                          "linear-gradient(135deg, rgba(131, 193, 74, 0.15) 0%, rgba(131, 193, 74, 0.08) 100%)",
                        textDecoration: "none",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background =
                          "linear-gradient(135deg, rgba(131, 193, 74, 0.3) 0%, rgba(131, 193, 74, 0.2) 100%)";
                        e.currentTarget.style.borderColor =
                          "rgba(131, 193, 74, 0.5)";
                        e.currentTarget.style.transform = "translateY(-3px)";
                        e.currentTarget.style.boxShadow =
                          "0 6px 20px rgba(131, 193, 74, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background =
                          "linear-gradient(135deg, rgba(131, 193, 74, 0.15) 0%, rgba(131, 193, 74, 0.08) 100%)";
                        e.currentTarget.style.borderColor =
                          "rgba(131, 193, 74, 0.3)";
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 2px 8px rgba(0, 0, 0, 0.15)";
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <div
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "8px",
                            background: "rgba(131, 193, 74, 0.3)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid rgba(131, 193, 74, 0.4)",
                          }}
                        >
                          <i
                            className="bi bi-box-arrow-right"
                            style={{ fontSize: "1rem", color: "#a8d97f" }}
                          ></i>
                        </div>
                        <span
                          className="ms-3 fw-semibold"
                          style={{ fontSize: "0.9rem", letterSpacing: "0.3px" }}
                        >
                          Sign Out
                        </span>
                      </div>
                      <i
                        className="bi bi-chevron-right"
                        style={{
                          fontSize: "0.8rem",
                          color: "#a8d97f",
                          opacity: 0.7,
                        }}
                      ></i>
                    </button>
                  </div>
                </nav>
              </div> */}
              <div
                className="offcanvas-body p-0 text-white"
                style={{
                  background: "#0A1F13",
                  minHeight: "100vh",
                  fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                }}
              >
                {/* Subtle accent line */}
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: "2px",
                    background:
                      "linear-gradient(180deg, #83c14a 0%, transparent 100%)",
                    opacity: 0.4,
                  }}
                ></div>

                <nav
                  className="d-flex flex-column h-100"
                  style={{ position: "relative" }}
                >
                  {/* Header Section */}
                  <div
                    className="text-center py-4 px-3"
                    style={{
                      borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
                    }}
                  >
                    {/* Avatar */}
                    <div style={{ marginBottom: "16px" }}>
                      <LogoHolder
                        className="bg-white"
                        textClassName="text-dark"
                        logo={user.picture}
                        name={user.username}
                        style={{
                          border: "2px solid rgba(131, 193, 74, 0.3)",
                          boxShadow: "0 2px 12px rgba(131, 193, 74, 0.15)",
                        }}
                      />
                    </div>

                    {/* User Name */}
                    <p
                      className="text-white mb-2 fw-semibold"
                      style={{
                        fontSize: "0.95rem",
                        letterSpacing: "0.2px",
                        lineHeight: "1.4",
                      }}
                    >
                      {user.name || user.username}
                    </p>

                    {/* Role Badge */}
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        background: "rgba(131, 193, 74, 0.12)",
                        padding: "4px 12px",
                        borderRadius: "6px",
                        border: "1px solid rgba(131, 193, 74, 0.2)",
                      }}
                    >
                      <i
                        className="bi bi-cup-hot-fill"
                        style={{ color: "#83c14a", fontSize: "0.7rem" }}
                      ></i>
                      <small
                        className="fw-medium"
                        style={{
                          color: "rgba(255, 255, 255, 0.8)",
                          fontSize: "0.7rem",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                        }}
                      >
                        BI - Analytics
                      </small>
                    </div>
                  </div>

                  {/* Menu Section */}
                  <div
                    className="flex-grow-1 overflow-auto px-3 py-3"
                    style={{
                      scrollbarWidth: "thin",
                      scrollbarColor: "rgba(131, 193, 74, 0.3) transparent",
                    }}
                  >
                    <Menu
                      onClickItem={this.onClickMenu.bind(this)}
                      menus={this.filterAccess(menus, roles)}
                    />
                  </div>

                  {/* Sign Out Section */}
                  <div
                    className="mt-auto"
                    style={{
                      borderTop: "1px solid rgba(255, 255, 255, 0.08)",
                      padding: "16px",
                    }}
                  >
                    <button
                      className="nav-link text-white btn btn-link w-100 text-start p-0 d-flex align-items-center justify-content-between"
                      onClick={this.onClickSignOut.bind(this)}
                      style={{
                        transition: "all 0.2s ease",
                        padding: "12px 14px",
                        borderRadius: "8px",
                        border: "1px solid transparent",
                        background: "transparent",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background =
                          "rgba(131, 193, 74, 0.08)";
                        e.currentTarget.style.borderColor =
                          "rgba(131, 193, 74, 0.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "transparent";
                        e.currentTarget.style.borderColor = "transparent";
                      }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <i
                          className="bi bi-box-arrow-right"
                          style={{
                            fontSize: "1.1rem",
                            color: "rgba(255, 255, 255, 0.6)",
                          }}
                        ></i>
                        <span
                          className="fw-medium"
                          style={{
                            fontSize: "0.9rem",
                            color: "rgba(255, 255, 255, 0.8)",
                          }}
                        >
                          Sign Out
                        </span>
                      </div>
                      <i
                        className="bi bi-chevron-right"
                        style={{
                          fontSize: "0.75rem",
                          color: "rgba(255, 255, 255, 0.4)",
                        }}
                      ></i>
                    </button>
                  </div>
                </nav>
              </div>
            </OffCanvas>
          )}
        </Layout.Context.Consumer>
        <main className="vh-100 d-flex flex-column">
          <Routes>
            {/* <Route exact path={"/"} element={<DashboardPage />} /> */}
            {/*<Route*/}
            {/*  exact*/}
            {/*  path={"/collection/dashboard"}*/}
            {/*  element={<DashboardPage />}*/}
            {/*/>*/}
            {/* <Route path="/" element={}/> */}
            <Route
              exact
              path={"/collection/:name"}
              element={<CollectionListPage />}
            />
            <Route path={"/collection/roles/form"} element={<RoleFormPage />} />
            <Route
              path={"/collection/roles/form/:id"}
              element={<RoleFormPage />}
            />
            <Route
              path={"/collection/:name/form/"}
              element={<CollectionFormPage />}
            />
            <Route
              path={"/collection/:name/form/:id"}
              element={<CollectionFormPage />}
            />
            <Route path={"/migration"} element={<MigrationPage />} />
            <Route path={"/schema"} element={<SchemaPage />} />
            <Route path={"/account"} element={<AccountPage />} />
            <Route path={"/hooks"} element={<HooksPage />} />
            <Route path={"/function"} element={<FunctionPage />} />
            {/* start */}
            <Route path={"/sales&transactions"} element={<SaleTransPage />} />
            <Route path={"/grossSales"} element={<GrossSalesPage />} />
            <Route
              path={"/totalTransaction"}
              element={<TotalTransactionPage />}
            />
            <Route path={"/totalGuest"} element={<TotalGuestPage />} />
            <Route path={"/discountCost"} element={<DiscountCostPage />} />
            {/* productModule */}
            <Route path={"/products"} element={<ProductsPage />} />
            <Route path={"/products-search"} element={<ProductSearchPage />} />
            {/* <Route path={"/products/masterlist"} element={<ProductSearchPage />} /> */}
            <Route path={"/itemSold"} element={<ItemSoldPage />} />
            <Route path={"/top10"} element={<Top10ItemsPage />} />
            {/* customerModule */}
            <Route path={"/customers"} element={<CustomerPage />} />
            {/* reportModule */}
            <Route path={"/report"} element={<ReportPage />} />
            <Route path={"/dashboard"} element={<ReportDashPage />} />
            <Route path={"/logs"} element={<LogsPage />} />
            {/* Transaction Route  */}
            <Route exact path={"/transactions"} element={<TransactionPage />} />
            {/* Food Cost Route */}
            <Route
              exact
              path={"/collection/raw_materials/list"}
              element={<RawMaterialPage />}
            />
            <Route
              exact
              path={"/collection/raw_material/form"}
              element={<RawMaterialFormPage />}
            />
            <Route
              exact
              path={"/collection/category/list"}
              element={<CategoryPage />}
            />
            <Route
              exact
              path={"/collection/category/form"}
              element={<CategoryFormPage />}
            />
            <Route
              exact
              path={"/collection/category/form/:id"}
              element={<CategoryFormPage />}
            />
            <Route
              exact
              path={"/collection/raw_material/form/:id"}
              element={<RawMaterialFormPage />}
            />
            <Route
              exact
              path={"/collection/components/list"}
              element={<ComponentsPage />}
            />
            <Route
              exact
              path={"/collection/component/form"}
              element={<ComponentsFormPage />}
            />
            <Route
              exact
              path={"/collection/component/form/:id"}
              element={<ComponentsFormPage />}
            />
            <Route
              exact
              path={"/collection/products/list"}
              element={<ProductPage />}
            />
            <Route
              exact
              path={"/collection/product/form"}
              element={<ProductFormPage />}
            />
            <Route
              exact
              path={"/collection/product/form/:id"}
              element={<ProductFormPage />}
            />
            <Route
              exact
              path={"/collection/audit_logs/list"}
              element={<AuditLogsPage />}
            />
            <Route
              exact
              path={"/collections/inventory/list"}
              element={<InventoryPage />}
            />
            <Route
              exact
              path={"/collection/inventory/form"}
              element={<InventoryFormPage />}
            />
            <Route
              exact
              path={"/collection/inventory/form/:id"}
              element={<InventoryFormPage />}
            />
            <Route
              exact
              path={"/collection/inventory_logs/list"}
              element={<InventoryLogsPage />}
            />
            <Route
              exact
              path={"/collection/partial_logs/list"}
              element={<PartialLogsPage />}
            />
            <Route
              exact
              path={"/collection/partial_logs/form/:id"}
              element={<PartialLogsFormPage />}
            />
            <Route
              exact
              path={"/collection/backup_pullouts/list"}
              element={<PullOutPage />}
            />
            <Route
              exact
              path={"/collection/backup_pullouts/form"}
              element={<PullOutFormPage />}
            />
            <Route
              exact
              path={"/collection/backup_pullouts/form/:id"}
              element={<PullOutFormPage />}
            />
            <Route
              exact
              path={"/collection/backup_pullouts/form/view/:id"}
              element={<PullOutFormPage />}
            />
            {/* Direct Purchase Route */}
            <Route
              exact
              path={"/collection/direct_purchace/list"}
              element={<DirectPurchacePage />}
            />
            <Route
              exact
              path={"/collection/direct_purchaces/form"}
              element={<DirectPurchaseFormPage />}
            />
            <Route
              exact
              path={"/collection/direct_purchaces/form/:id"}
              element={<DirectPurchaseFormPage />}
            />
            {/* Stock Transfer Route */}
            <Route
              exact
              path={"/collection/stock_request/list"}
              element={<StockRequestPage />}
            />
            <Route
              exact
              path={"/collection/stock_request/form"}
              element={<StockRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/stock_request/form/:id/:view"}
              element={<StockRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/stock_request/form/:id/:reconcile"}
              element={<StockRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/stock_request/form/:id/:receive"}
              element={<StockRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/stock_request/form/:id/:partial"}
              element={<StockRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/stock_transfers/list"}
              element={<TransferHistoryPage />}
            />
            <Route
              exact
              path={"/collection/stock_transfers/form/:id"}
              element={<TransferHistoryFormPage />}
            />
            <Route
              exact
              path={"/collection/upcoming_request/list"}
              element={<UpcomingRequestPage />}
            />
            <Route
              exact
              path={"/collection/upcoming_request/form/:id"}
              element={<UpcomingRequestFormPage />}
            />
            <Route
              exact
              path={"/collection/upcoming_request/form/:id/:approve"}
              element={<UpcomingRequestFormPage />}
            />
            {/* Packaging Route */}
            <Route
              exact
              path={"/collection/packaging_breakdown/list"}
              element={<PackagingBreakdownPage />}
            />
            <Route
              exact
              path={"/collection/packaging_breakdown/form"}
              element={<PackagingBreakdownFormPage />}
            />
            <Route
              exact
              path={"/collection/packaging_breakdown/form/:id"}
              element={<PackagingBreakdownFormPage />}
            />
            <Route
              exact
              path={"/collection/packaging_breakdown/form/:id/:view"}
              element={<PackagingBreakdownFormPage />}
            />
            {/* Receivable Route */}
            <Route
              exact
              path={"/collection/receivable_item/list"}
              element={<ReceivableItemPage />}
            />
            <Route
              exact
              path={"/collection/receivable_items/form/:name"}
              element={<ReceivableItemFormPage />}
            />
            <Route
              exact
              path={"/collection/receivable_items/form/name/:id"}
              element={<ReceivableItemFormPage />}
            />
            <Route
              exact
              path={"/collection/receivable_items/form/:id/:view"}
              element={<ReceivableItemFormViewPage />}
            />
            {/* Waste Route */}
            <Route
              exact
              path={"/collection/waste_raw_materials/list"}
              element={<WasteRawPage />}
            />
            <Route
              exact
              path={"/collection/waste_raw_materials/form"}
              element={<WasteRawFormPage />}
            />
            <Route
              exact
              path={"/collection/waste_components/list"}
              element={<WasteComponentPage />}
            />
            <Route
              exact
              path={"/collection/waste_components/form"}
              element={<WasteComponentFormPage />}
            />
            <Route
              exact
              path={"/collection/waste_product/list"}
              element={<WasteProductPage />}
            />
            <Route
              exact
              path={"/collection/waste_product/form"}
              element={<WasteProductFormPage />}
            />

            {/* Report Route */}
            <Route
              exact
              path={"/collection/report/list"}
              element={<ReportsPage />}
            />

            {/* <Route
              exact
              path={"/collection/inventory_logs/list"}
              element={<InventoryPage />}
            /> */}
            <Route element={<NotFoundPage />} />
          </Routes>
        </main>
      </Layout>
    );
  }
}

export default withRouter(MainPage);
